export default __webpack_public_path__ + "static/media/TWB-color.32e89bfd.png";